<template>
  <div>
    <b-modal id="removeAoModal" @hide="handleClose">
      <template #modal-header="{ close }">
        <h5>Nhân viên chăm sóc phụ cần gỡ gán</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="">
        <span class="required mb-1">Lý do gỡ gán</span>
        <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
          <form @submit.prevent="handleSubmit(handleRemoveAO)">
            <ValidationProvider
              rules="required|minMaxName_4"
              name="Lý do gỡ gán"
              v-slot="{ errors }"
            >
              <b-form-group label="" label-for="floatingTextarea2">
                <b-form-textarea
                  id="floatingTextarea2"
                  v-model="reason"
                  placeholder="Nhập lý do gỡ gán"
                  rows="2"
                  max-rows="6"
                  :state="errors.length > 0 ? false : null"
                >
                </b-form-textarea>
                <b-form-invalid-feedback id="input-live-feedback">{{
                  errors[0]
                }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </form>
        </ValidationObserver>
      </div>
      <div>
        <p class="f14 pb-2">Danh sách nhân viên</p>
        <b-form-group>
          <template #label>
            <b-form-checkbox
              v-model="allSelected"
              :indeterminate="indeterminate"
              aria-describedby="secondStaff"
              aria-controls="secondStaff"
              @change="toggleAll"
            >
              <span class="font-size-14">Nhân viên chăm sóc</span>
            </b-form-checkbox>
          </template>
          <template v-slot="{ ariaDescribedby }">
            <b-form-checkbox-group
              id="staff"
              v-model="selected"
              :aria-describedby="ariaDescribedby"
              name="flavors"
              class="list-cb ml-4"
              aria-label="Individual secondStaff"
              stacked
            >
              <b-form-checkbox
                v-for="staff in secondStaff"
                :key="staff.staffId"
                :value="staff.staffId"
              >
                <span>{{ staff.staffName || 'undefined' }}</span>
                <span v-for="(type, index) in staff.staffTypes" :key="index">
                  - {{ getBusinessTypeName(type) }}
                </span>
              </b-form-checkbox>
            </b-form-checkbox-group>
          </template>
        </b-form-group>
        <span class="text-danger">{{ emptySelected }}</span>
      </div>
      <template #modal-footer="{ close }">
        <b-button size="sm" variant="light" @click="close()"> Huỷ bỏ </b-button>
        <b-button size="sm" variant="primary" @click="handleRemoveAO"> Đồng ý </b-button>
      </template>
    </b-modal>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="false"></VueLoadingOverlay>
  </div>
</template>

<script>
  import { RemoveMany } from '@/services/customer-support/assign_order'
  import { CommonService } from '@/services/common.service'

  export default {
    props: {
      secondStaff: {
        type: [],
        default: () => [],
      },
      levelAssign: {
        type: String,
        default: 'MERCHANT_ACCOUNT',
      },
    },
    computed: {
      getBusinessTypeName() {
        return mcc => {
          const objStatus = this.dataConfigMcc.find(s => s.code === mcc)
          return objStatus ? objStatus.name : mcc
        }
      },
    },
    data() {
      return {
        reason: '',
        emptySelected: '',
        selected: [],
        dataConfigMcc: [],
        loading: false,
        allSelected: false,
        indeterminate: false,
      }
    },
    watch: {
      selected(newValue, oldValue) {
        // Handle changes in individual flavour checkboxes
        if (newValue.length === 0) {
          this.indeterminate = false
          this.allSelected = false
        } else if (newValue.length === this.secondStaff.length) {
          this.indeterminate = false
          this.allSelected = true
          this.emptySelected = ''
        } else {
          this.indeterminate = true
          this.allSelected = false
          this.emptySelected = ''
        }
      },
    },
    methods: {
      show() {
        this.$bvModal.show('removeAoModal')
      },
      toggleAll(checked) {
        this.selected = checked ? this.secondStaff.map(staff => staff.staffId) : []
      },
      async handleRemoveAO() {
        try {
          const isValid = await this.$refs.observer.validate()

          if (this.selected.length === 0) {
            this.emptySelected = 'Vui lòng chọn ít nhất 1 nhân viên'
            return
          } else if (!isValid) return

          this.loading = true
          const res = await RemoveMany({
            levelAssign: this.levelAssign,
            assignmentId: this.$router.currentRoute.params.id,
            staffIds: this.selected,
            configType: 'SECOND',
            reason: this.reason,
          })
          if (res.result) {
            await this.$emit('loadData')
            this.$bvModal.hide('removeAoModal')
            this.showToastSuccess('Gỡ nhân viên chăm sóc thành công')
          }
          this.loading = false
        } catch (e) {
          this.loading = false
          this.showToastError(e.message)
        }
      },
      handleClose() {
        this.reason = ''
        this.selected = []
      },
      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.dataConfigMcc = data.data.businessFields
            }
          })
          .catch(error => console.error(error))
      },
    },
  }
</script>

<style lang="scss" scoped>
  ::v-deep(.custom-control-label) {
    padding-top: 0.25em;
  }
  .required::after {
    content: '*';
    color: red;
    margin-left: 4px;
  }
  .list-cb {
    position: relative;
    height: 50vh;
    overflow-y: scroll;
  }
  ::v-deep(.modal-footer) {
    justify-content: space-between;
  }
</style>
